export enum ResourceTypes {
  WDT = 'wdt',
  MUSIC = 'music',
  VIDEO = 'video',
  LETTER_VIDEO = 'letter-video',
  DOWNLOADABLE_RESOURCE = 'downloadable-resource',
  SUPPORT = 'support',
  AUDIO = 'audio',
  MATCH_IT_TRASH_IT = 'match-it-trash-it',
  STARTING_SOUND = 'starting-sound',
  DID_YOU_KNOW = 'did-you-know',
  WALL_CARD = 'wall-card',
}
